/**
 * Client-side Sentry `ignoreErrors` patterns: third-party noise that is dropped before it becomes a
 * Sentry issue. Sentry checks these alongside its own `DEFAULT_IGNORE_ERRORS`, matching them
 * against the event message, the exception value and `"<type>: <value>"`. Every entry must be
 * anchored and carry the evidence that it is not first-party — see docs/SENTRY_NOISE_FILTERING.md
 * before adding one.
 */
export const SENTRY_IGNORE_ERRORS: (string | RegExp)[] = [
  /**
   * COO-WEBAPP-4G (TEAM-15054). A promise rejected with the primitive string
   * `Object Not Found Matching Id:<n>, MethodName:<name>, ParamCount:<n>`, which the SDK reports as
   * a frameless `UnhandledRejection`. No code in this repo or its dependencies produces the string
   * (its only occurrence is Sentry's own `simulateEvent` default in `@sentry/core`), and 316/316
   * source IPs over 90 days were Microsoft-owned, with replays showing no diner interaction.
   * Sentry already drops the `MethodName:simulateEvent` sibling by default ("CEFSharp"); this
   * widens it to any method name.
   */
  /^Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+, MethodName:\w+, ParamCount:\d+$/,
];
